import { remCalc } from '@mnd-frontend/ui/publish/utils';
import { SIZING_5_5, SPACING_1, SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useNewsroomSetup } from '../../../../contexts/NewsroomSetupContext';

const Content = styled.div<{ $color: string }>`
  width: 100%;
  height: 100%;
  border-radius: 6px;
  position: relative;
  padding: ${SPACING_3};
  background-color: ${props => props.$color};
  color: white;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: ${SIZING_5_5};
    border-radius: 6px 6px 0 0;
    background: white;
  }
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-top: ${remCalc(20)};
  align-items: center;
  justify-content: center;
`;

const SubFielsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING_1};
  p {
    margin: 0;
    font-size: ${remCalc(14)};
  }
`;

const PreviewCompanyInformation = () => {
  const { t } = useTranslation();
  const { newsroomData } = useNewsroomSetup();
  const { secondaryBrandColor } = newsroomData.branding;
  const { city, companyName, country, postalCode, street } = newsroomData['company-information'];

  return (
    <Content $color={secondaryBrandColor}>
      <CompanyInfo>
        <p>
          <b>{companyName || t('newsroom_settings-general_settings-company_name-input_label')}</b>
        </p>
        <SubFielsWrapper>
          <p>{street || t('newsroom_settings-footer_settings-street-input_label')}</p>
          <p>
            {postalCode || t('newsroom_settings-footer_settings-post_code-input_label')}{' '}
            {city || t('common_city')}
          </p>
          <p>{country || t('common_country')}</p>
        </SubFielsWrapper>
      </CompanyInfo>
    </Content>
  );
};

export default PreviewCompanyInformation;
